module.exports = __webpack_public_path__ + "static/media/linkedin.3c57defa.svg";